/* eslint-disable @typescript-eslint/no-explicit-any */
import type { HResponse } from './types';

export const handleResponse = async <T>(response: Response): Promise<HResponse<T>> => {
  try {
    const json = await response.json();
    return parseJsonResponse<T>(json);
  } catch {
    return parseNonJsonResponse<T>(response);
  }
};

const parseJsonResponse = <T>(json: any): HResponse<T> => {
  if (json.status === 'success') {
    return { status: 'success', data: json.data || {} };
  }
  if (json.status === 'error') {
    return { status: 'error', messages: json.messages || ['Network Error'] };
  }
  return { status: 'success', data: {} as T };
};

const parseNonJsonResponse = <T>(response: Response): HResponse<T> => {
  if (response.status >= 400) {
    return { status: 'error', messages: ['Network Error'] };
  } else {
    return { status: 'success', data: {} as T };
  }
};
